export const QUOTA_PLAN_TYPE = {
  CREDIT: 'Credit',
  SUBSCRIPTION: 'Subscription',
  UNLIMITED: 'Unlimited',
} as const;
